import { render } from "./RecurringUX.vue?vue&type=template&id=c8d2edd2&scoped=true"
const script = {}

import "./RecurringUX.vue?vue&type=style&index=0&id=c8d2edd2&scoped=true&lang=css"

import exportComponent from "/home/runner/work/helixpay-website/helixpay-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8d2edd2"]])

export default __exports__